import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import UploadPage from './pages/UploadPage';
import AdminPage from './pages/AdminPage';
import UpdatePage from './pages/UpdatePage';
import './index.css';

const App: React.FC = () => {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-white to-gray-50">
        <Routes>
          <Route path="/" element={<UploadPage />} />
          <Route path="/update/:uploadLink" element={<UpdatePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
